import React, { useState } from "react";
import { FileSearch, Loader2, ExternalLink } from "lucide-react";
import { api } from "../lib/api";

export const ResearchCard = () => {
  const [ticker, setTicker] = useState("");
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const [err, setErr] = useState("");
  const run = async () => {
    if (!ticker.trim()) return;
    setBusy(true); setErr(""); setRes(null);
    try {
      const r = await api.post("/trading/research", { ticker: ticker.trim() }, { timeout: 120000 });
      if (r.data.error) setErr(r.data.error); else setRes(r.data);
    } catch (e) { setErr("Research failed — try again in a minute."); }
    finally { setBusy(false); }
  };
  return (
    <div className="bg-[#060b18] border border-[#00F0FF22] rounded-2xl p-4 space-y-3" data-testid="research-card">
      <p className="text-xs nx-mono tracking-widest text-cyan-300/70 flex items-center gap-2"><FileSearch className="w-4 h-4" /> Research (SEC EDGAR)</p>
      <div className="flex gap-2">
        <input value={ticker} onChange={(e) => setTicker(e.target.value.toUpperCase())} onKeyDown={(e) => e.key === "Enter" && run()} placeholder="Ticker, e.g. TSLA" data-testid="research-ticker-input"
          className="flex-1 bg-[#030712] border border-[#00F0FF22] rounded-lg px-3 py-1.5 text-sm text-white nx-mono outline-none focus:border-[#00F0FF66]" />
        <button onClick={run} disabled={busy} data-testid="research-run-btn" className="px-3 py-1.5 rounded-lg text-xs font-bold text-[#00F0FF] border border-[#00F0FF44] hover:bg-[#00F0FF11] flex items-center gap-1 disabled:opacity-50">
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <FileSearch className="w-3.5 h-3.5" />} {busy ? "Reading filings…" : "Run"}
        </button>
      </div>
      {err && <p className="text-xs text-rose-300" data-testid="research-error">{err}</p>}
      {res && (
        <div className="space-y-2" data-testid="research-results">
          {res.bullets.map((b, i) => (
            <div key={i} className="text-sm text-cyan-50/90 leading-snug border-l-2 border-[#00F0FF44] pl-3" data-testid={`research-bullet-${i}`}>
              {b.text}
              <div className="flex items-center gap-3 mt-0.5 nx-mono text-[11px]">
                <span className="text-cyan-200/50">as of {b.as_of || "--"}</span>
                <a href={b.source_url} target="_blank" rel="noreferrer" className="text-[#00F0FF] hover:underline flex items-center gap-1 truncate" data-testid={`research-source-${i}`}>source <ExternalLink className="w-3 h-3" /></a>
              </div>
            </div>
          ))}
          {!res.bullets.length && <p className="text-xs text-cyan-200/50">No cited findings for {res.ticker}.</p>}
          <p className="text-[10px] text-cyan-200/40">{res.disclaimer}</p>
        </div>
      )}
    </div>
  );
};
